import { Component, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShowLoaderScreenService } from './core/services/show-loader-screen.service';
import { ToastModule } from 'primeng/toast';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('wallet');

  constructor(
    _ShowLoaderScreenService: ShowLoaderScreenService,
    private languageService: LanguageService
  ) {
    // Language service initializes automatically via effect()
  }

  ngOnInit(): void {
    // Language is initialized in LanguageService constructor
  }
}
